import { styled } from '@mui/material/styles'

export const BackdropWrapper = styled('div')(({ theme }) => ({
  '& .solid': {
    backgroundColor: theme.palette.background.default, // theme.palette.background.default (too dark!),
  },
}))
